import React, {Component} from "react"

class OpenCollapseToggle extends Component {
  constructor(){
    super()
    this.state = {
      isOpen: false
    }
  }
  render() {
    const isOpen = this.state.isOpen
    return (
      <i className={`open-collapse-toggle fa fa-${isOpen?'minus':'plus'}-circle custom-link`}
         onClick={()=>{
           this.setState({isOpen:!isOpen})}}/>
    )
  }
}

export default OpenCollapseToggle



// WEBPACK FOOTER //
// ./src/components/OpenCollapseToggle.js